
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import moment from "moment";
import { encryptText } from "./decrypt";

export const generateDeviceId = () => {
  return new Promise((resolve, reject) => {
    FingerprintJS.load().then((fp) => {
      fp.get().then((result) => {
        const visitorId = result.visitorId;
        resolve(visitorId);
      });
    });
  });
};
const getHalfHour = () => {
  const hour = Math.floor(new Date().getHours() / 2);
  if (hour < 10) {
    return "0" + hour.toString();
  } else {
    return hour.toString();
  }
};
export const generateTimeToken = () => {
  const date = Math.floor(new Date().getTime() / 1000 + 20);
  const dateString = date.toString();
  const hour = getHalfHour();
  const curTime = moment().format("YYYYMMDD") + hour;
  const timeToken = encryptText(dateString);
  return {
    timeToken,
    curTime,
  };
};
export default generateDeviceId
